import { render, staticRenderFns } from "./PrSlideOrNot.vue?vue&type=template&id=7efb0496&"
import script from "./PrSlideOrNot.vue?vue&type=script&lang=js&"
export * from "./PrSlideOrNot.vue?vue&type=script&lang=js&"
import style0 from "./PrSlideOrNot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports